export const QA_NAME_POST_CREATOR = 'creator'
